export default "__VITE_ASSET__CZUc9Gso__"